import React from "react";

import { Box, Paper, Typography } from "@mui/material";

import { useSelectedLocationDropdown } from "../../../common/variables/selectedLocationDropdown";
import CreateDevicesFromSKUDialogContainer from "./CreateDevicesFromSKUDialogContainer";

/* TODO: Refactoring of DevicesTableNoRowsOverlay
    1. Implement reusable component
    2. Rewrite CreateDeviceDialogContainer to redirect button
    3. Rewrite CircularLoading, move it over Paper
*/

const DevicesTableNoRowsOverlayComponent = (): JSX.Element => {
  const selectedLocation = useSelectedLocationDropdown();

  return (
    <Paper
      sx={{
        height: "240px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <>
          <Typography variant="h4">
            There is no devices
            {selectedLocation?.title ? ` in ${selectedLocation?.title}` : ""}
          </Typography>
          <Typography
            style={{ marginBottom: 24 }}
            variant="body1Regular"
            color="text.secondary"
          >
            Add devices to manage them
          </Typography>

          {/* <CreateDeviceDialogContainer overlay /> */}
          <CreateDevicesFromSKUDialogContainer overlay />
        </>
      </Box>
    </Paper>
  );
};

const DevicesTableNoRowsOverlay = React.memo(
  DevicesTableNoRowsOverlayComponent
);

export default DevicesTableNoRowsOverlay;
